import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {FilterRecordsButton} from "../buttons/FilterRecordsButton.tsx";
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";

const useTools = () => {
    // Read-only module (FNP-535): no Add/Delete. The list is per-channel (the GSI
    // partition key is required); FNP-607 surfaces the channel through the standard
    // Filter button + drawer (default STRIPE, required/non-clearable). Plus Reload.
    const tools = [];

    tools.push(<FilterRecordsButton key='filter'/>);
    tools.push(<ReloadRecordsButton key='reload'/>);

    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get('Reconciliation Reports')}
            tools={useTools()}
        />
    );
};
